import { Action, createReducer, on } from '@ngrx/store';

import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { fromTaxYearsActions } from '../actions';
import { IYears } from '../models/years.model';

export const taxYearsFeatureKey = 'taxYears';

export interface TaxYearsState {
  taxYearsRequest: any;
  taxYearsResponse: IYears[];
  taxYearsFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: TaxYearsState = {
  taxYearsRequest: undefined,
  taxYearsResponse: undefined,
  taxYearsFailure: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromTaxYearsActions.loadTaxYearss, (state, action) => ({
    ...state,
    taxYearsRequest: action.request
  })),
  on(fromTaxYearsActions.loadTaxYearssSuccess, (state, action) => ({
    ...state,
    taxYearsResponse: action.response,
    loaded: true
  })),
  on(fromTaxYearsActions.loadTaxYearssFailure, (state, action) => ({
    ...state,
    taxYearsFailure: action.error
  }))
);

export const getTaxYearsRequest = (state: TaxYearsState) => state.taxYearsRequest;
export const getTaxYearsResponse = (state: TaxYearsState) => {
  return state.taxYearsResponse;
};
export const getTaxYearsFailure = (state: TaxYearsState) => state.taxYearsFailure;

export const getTaxYearsIsLoaded = (state: TaxYearsState) => state.loaded;
